<template>
  <a-card class="m-height-full m-display-flex flex-column nowrap w-head relative-wrap z0">
    <template slot="title">
      <h4 class="margin-remove"><a-icon type="wallet" />&nbsp;Financial Accounting</h4>
    </template>
    <!-- For Desktop -->
    <template v-if="!getScreen && getAuth.divisi[0] == 'Akuntansi'">
      <div @click="onMegaMenu()" slot="extra" class="mega-menu" :class="mega.isOpen ? 'active' : ''">
        <a-icon :type="mega.isOpen ? 'up-square' : 'down-square'"></a-icon>
        Menu
      </div>
      <div class="mega-menu__wrapper" :class="mega.isOpen ? 'active' : ''">
        <div class="mega-menu__backdrop"></div>
        <div class="mega-menu__body">
          <h4 class="mega-menu__title">FINANCIAL ACCOUNTING MENU</h4>
          <div class="mega-menu__list">
            <a-row>
              <a-col class="single-menu" :span="8">
                <div @click="handleMenu(item)" v-for="item in subNavigation.lev1" :key="item.id_menu">
                  {{ item.label_menu }}
                  <a-badge class="m-badge m-badge-small" :count="countNotif(item)"
                    :numberStyle="{ backgroundColor: 'red' }"></a-badge>
                </div>
              </a-col>
              <a-col class="multi-menu" :span="16">
                <div v-for="item in subNavigation.lev2" :key="item.id_menu">
                  <div class="title">
                    <label class="title">{{ item.label_menu }}</label>
                    <a-badge class="m-badge m-badge-small" :count="countNotif(item)"
                      :numberStyle="{ backgroundColor: 'red' }"></a-badge>
                  </div>
                  <div class="menu-label" v-for="data in item.child" :key="data.id_menu" @click="handleMenu(data)">
                    {{ data.label_menu }}
                    <a-badge class="m-badge m-badge-small" :dot="data.notif !== null"></a-badge>
                  </div>
                </div>
              </a-col>
            </a-row>
          </div>
        </div>
      </div>
    </template>

    <!-- For Mobile -->
    <template v-if="getScreen">
      <div @click="onMegaMenu()" slot="extra" class="mega-menu" :class="mega.isOpen ? 'active' : ''">
        <a-icon :type="mega.isOpen ? 'menu-fold' : 'menu-unfold'"></a-icon>
      </div>
      <a-drawer title="Financial Menu" placement="right" :closable="false" :visible="mega.isOpen" width="280"
        :body-style="{ padding: '0' }" @close="onMegaMenu()" v-if="getScreen">
        <a-menu mode="inline">
          <a-menu-item v-for="item in subNavigation.lev1" :key="item.id_menu">
            <router-link :to="item.link_menu">
              <a-icon :type="item.icon_menu" />
              {{ item.label_menu }}
              &nbsp;
              <a-badge class="m-badge m-badge-small" :count="countNotif(item)"
                :numberStyle="{ backgroundColor: 'red' }"></a-badge>
            </router-link>
          </a-menu-item>
          <a-sub-menu v-for="item in subNavigation.lev2" :key="item.id_menu">
            <span slot="title">
              <a-icon :type="item.icon_menu" />
              <span>{{ item.label_menu }}</span>
              &nbsp;
              <a-badge class="m-badge m-badge-small" :count="countNotif(item)"
                :numberStyle="{ backgroundColor: 'red' }"></a-badge>
            </span>

            <a-menu-item v-for="childmenu in item.child" :key="childmenu.id_menu">
              <router-link :to="childmenu.link_menu">
                <div class="m-display-flex space-between align-middle">
                  <div>
                    <a-icon :type="childmenu.icon_menu" />
                    <span>{{ childmenu.label_menu }}</span>
                  </div>
                  &nbsp;
                  <a-badge class="m-badge m-badge-small" :count="childmenu.notif"
                    :numberStyle="{ backgroundColor: 'red' }"></a-badge>
                </div>
              </router-link>
            </a-menu-item>
          </a-sub-menu>
        </a-menu>
      </a-drawer>
    </template>
    <router-view :key="$route.fullPath"></router-view>
  </a-card>
</template>

<script>
import { mapGetters, mapActions } from "vuex";
import _ from "lodash";
import Axios from "axios";
import notificationCount from "@/mixins/NotificationCount";

export default {
  name: "akuntansiKeuangan",
  data() {
    return {
      loading: true,
      visible: false,
      currentMenu: {},
      mega: {
        isOpen: false,
      },
    };
  },
  mixins: [notificationCount],
  methods: {
    ...mapActions(["NAVIGATION_ACTION"]),
    hide() {
      this.visible = false;
    },
    countNotif(menu) {
      let hitungNotif = 0;
      if (
        (this.getNavigation !== undefined || this.getNavigation !== null) &&
        menu !== undefined
      ) {
        if (menu.child.length > 0) {
          menu.child.forEach((element) => {
            if (element.notif !== "null" || element.notif !== null) {
              hitungNotif = hitungNotif + Number(element.notif);
            }
          });
        } else {
          if (menu.notif !== "null" || menu.notif !== null) {
            hitungNotif = hitungNotif + Number(menu.notif);
          }
        }
      }
      return hitungNotif;
    },
    reloadNav() {
      Axios({
        method: "get",
        url: this.$serviceUrl + "menu/",
        params: {
          tlc: this.getAuth.username,
        },
        auth: {
          username: this.getAuth.username,
          password: this.getAuth.password,
        },
        headers: {
          "X-API-KEY": this.getAuth.apikey,
        },
      })
        .then((response) => {
          if (response !== undefined) {
            this.NAVIGATION_ACTION(response.data.data.slice(1));
          }
        })
        .catch((err) => {
          if (!err.response) {
            this.$router.push({ name: "noConnection" });
          }
        });
    },
    onMegaMenu() {
      this.mega.isOpen = !this.mega.isOpen;
    },
    hiddenMegaMenu() {
      this.mega.isOpen = false;
    },
    handleMenu(item) {
      this.$router.push(item.link_menu);
      this.mega.isOpen = false;
    },
  },
  computed: {
    ...mapGetters(["getAuth", "getScreen", "getNavigation"]),
    subNavigation() {
      let data = {
        lev1: [],
        lev2: [],
      };
      if (
        this.getNavigation !== undefined ||
        this.getNavigation !== null ||
        this.getNavigation.length <= 0
      ) {
        _.filter(this.getNavigation, (nav) => {
          if (
            nav.label_menu &&
            nav.label_menu.toLowerCase() == "akuntansi keuangan"
          ) {
            _.filter(nav.child, (item) => {
              if (item.child.length === 0) {
                data.lev1 = [...data.lev1, item];
              } else {
                data.lev2 = [...data.lev2, item];
              }
            });
          }
        });
      }

      return data;
    },
  },
  mounted() {
    Event.$on("trigfetchnotif", this.reloadNav);
    Event.$on("trigHideMegaMenu", this.hiddenMegaMenu);
    this.reloadNav();
  },
  beforeDestroy() {
    Event.$off("trigfetchnotif", this.reloadNav);
    Event.$off("trigHideMegaMenu", this.hiddenMegaMenu);
  },
};
</script>

<style scoped lang="less">
.mega-menu {
  background-color: whitesmoke;
  height: 35px;
  display: flex;
  align-items: center;
  padding: 0 12px;
  gap: 6px;
  justify-content: center;
  border-radius: 6px;
  cursor: pointer;
  transition: all ease-in-out 0.2s;

  &.active {
    background-color: @color-secondary;
    color: white;
  }

  &__title {
    font-weight: bold;
  }

  &__body {
    background-color: white;
    padding: @padding;
  }

  &__wrapper {
    z-index: 10;
    width: 100%;
    position: absolute;
    background-color: fade(black, 70%);
    left: 0;
    right: 0;
    top: 0;
    height: 0;
    -webkit-transition: all 300ms cubic-bezier(0.17, 0.04, 0.03, 0.94);
    -moz-transition: all 300ms cubic-bezier(0.17, 0.04, 0.03, 0.94);
    -ms-transition: all 300ms cubic-bezier(0.17, 0.04, 0.03, 0.94);
    -o-transition: all 300ms cubic-bezier(0.17, 0.04, 0.03, 0.94);
    transition: all 300ms cubic-bezier(0.17, 0.04, 0.03, 0.94);
    box-sizing: border-box;
    display: flex;
    flex-direction: column;
    border-bottom: 1px solid darken(white, 10);
    border-top: 1px solid darken(white, 10);
    overflow: hidden;

    &.active {
      height: 100%;
      overflow: auto;
      box-shadow: -2px 10px 14px 0px darken(white, 10);
    }
  }

  &__list {
    width: 100%;
    height: 100%;
    padding: 0;

    .single-menu {
      min-height: 400px;
      max-height: 97%;
      background-color: lighten(@color-secondary, 20);
      padding-bottom: @padding;
      border-end-end-radius: @padding * 2;
      border-end-start-radius: @padding * 2;
      border-bottom: 4px solid darken(@color-secondary, 20);
      overflow: hidden;

      >div {
        padding: @padding / 2 @padding;
        font-size: 1rem;
        font-weight: 500;
        transition: all ease-in-out 0.2s;

        &:hover {
          background-color: rgba(0, 0, 0, 0.2);
          cursor: pointer;
          font-weight: bold;
        }
      }
    }

    .multi-menu {
      padding-left: @padding;
      display: flex;
      flex-wrap: wrap;
      gap: @padding;

      .title {
        margin-bottom: @padding / 2;

        label {
          font-weight: 700;
        }
      }

      >div {
        flex: 0 30%;
        text-transform: uppercase;

        label {
          margin-right: @padding / 3;
        }

        .menu-label {
          text-transform: capitalize;
          display: block;
          padding: @padding / 2;
          border-left: 1px solid darken(white, 10);
          font-size: 0.875rem;
          font-weight: 500;
          transition: all ease-in-out 0.2s;

          &:hover {
            border-left-color: @color-primary;
            color: @color-primary;
            cursor: pointer;
          }
        }
      }
    }
  }
}

.z0 {
  z-index: 0;
}
</style>
